import React from "react";
import "./SignUp.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Header from "../../components/Header/Header";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, Tab } from "@mui/material";
import EmployeeSignup from "./EmployeeSignup";
import UserSignup from "./UserSignup";

const SignUp = () => {
  const [value, setValue] = React.useState("employee");
  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <Header />
      <div className="signUp_Container">
        <div className="signUp">
          <ToastContainer
            position="top-center"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
          <h3>Register</h3>
          <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList
              onChange={handleTabChange}
              aria-label="lab API tabs example"
              centered
            >
              <Tab value="employee" label="Employee" />
              <Tab value="external" label="External Users" />
            </TabList>
          </Box>
          <TabPanel value="employee">
            <EmployeeSignup />
          </TabPanel>
          <TabPanel value="external">
            <UserSignup />
          </TabPanel>
        </TabContext>
        </div>
      </div>
      {/* <Footer /> */}
    </>
  );
};

export default SignUp;
